import React from 'react';

/**
 * ValidationScripts.js - React replacement for _ValidationScriptsPartial.cshtml
 * 
 * Original CSHTML content:
 * <script src="~/lib/jquery-validation/dist/jquery.validate.min.js"></script>
 * <script src="~/lib/jquery-validation-unobtrusive/jquery.validate.unobtrusive.min.js"></script>
 * 
 * In React, we handle validation differently using:
 * 1. Built-in HTML5 validation
 * 2. Custom validation hooks and utilities
 * 3. Form validation libraries
 * 
 * This component provides validation functionality without jQuery dependencies.
 */

const ValidationScripts = () => {
  React.useEffect(() => {
    // Initialize any global validation behaviors if needed
    // This replaces the jQuery unobtrusive validation initialization
    
    // Add custom validation message styling
    const style = document.createElement('style');
    style.textContent = `
      .field-validation-error {
        color: #dc3545;
        font-size: 0.875em;
        margin-top: 0.25rem;
        display: block;
      }
      
      .field-validation-valid {
        display: none;
      }
      
      .input-validation-error {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }
      
      .validation-summary-errors {
        color: #dc3545;
        margin-bottom: 1rem;
        padding: 0.75rem 1.25rem;
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
        border-radius: 0.375rem;
      }
      
      .validation-summary-errors ul {
        margin-bottom: 0;
        padding-left: 1.25rem;
      }
      
      .validation-summary-valid {
        display: none;
      }
      
      .form-control.is-invalid {
        border-color: #dc3545;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath d='m5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .form-control.is-valid {
        border-color: #28a745;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='m2.3 6.73.8-.77-.88-.77.42-.42.88.78 1.75-1.75.43.42-2.18 2.18z'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
    `;
    
    if (!document.querySelector('#validation-styles')) {
      style.id = 'validation-styles';
      document.head.appendChild(style);
    }

    return () => {
      // Cleanup if needed
      const existingStyle = document.querySelector('#validation-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);

  // This component doesn't render anything visible
  // It just provides the validation styling and setup
  return null;
};

export default ValidationScripts;
